import request from '@/utils/request'

// 页面列表
export function adHtmlList(params) {
  return request({
    url: '/promotion_link/static_html_link/list',
    method: 'get',
    params
  })
}
// 创建页面
export function createAdHtml(data) {
  return request({
    url: `/promotion_link/static_html_link/create`,
    method: 'post',
    data
  })
}
// 更新
export function updateAdHtml(data) {
  return request({
    url: '/promotion_link/static_html_link/update',
    method: 'post',
    data
  })
}
// 删除
export function delAdHtml(data) {
  return request({
    url: `/promotion_link/static_html_link/del`,
    method: 'post',
    data
  })
}
// 页面详情
export function adHtmldetail(params) {
  return request({
    url: '/promotion_link/static_html_link/detail',
    method: 'get',
    params
  })
}
// 上传腾讯云
export function uoloadHtmlToTencent(data) {
  return request({
    url: '/promotion_link/static_html_link/upload_yun',
    method: 'post',
    data
  })
}

